// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b6fa2748","455":"722c78b5","488":"bbbfa1ac","977":"804e9a6f"}[chunkId] + ".chunk.js";
};